import { useMemo } from 'react';

import { useGET } from './useGET';

const toUrl = playerId => `/player/${playerId}`;

export default function usePlayer(playerId) {
  const url = toUrl(playerId);
  const data = useGET(url);

  return useMemo(() => data, [data]);
}
